import { StrategyProfile } from "@mutiny-group/sbo-openapi-client";
import { lowerCase } from "lodash";

export type StrategyStyle = {
  backgroundColor: string;
};

const StrategyProfileMap: { value: StrategyProfile; label: string; style: StrategyStyle }[] = [
  {
    value: StrategyProfile.Conservative,
    label: "Conservative",
    style: {
      backgroundColor: "#007ACC",
    },
  },
  {
    value: StrategyProfile.Moderate,
    label: "Moderate",
    style: {
      backgroundColor: "#F39C12",
    },
  },
  {
    value: StrategyProfile.Aggressive,
    label: "Aggressive",
    style: {
      backgroundColor: "#922B21",
    },
  },
];

export const getStrategyProfile = (strategyProfile: StrategyProfile | null | undefined) => {
  if (!strategyProfile) return null;
  return (
    StrategyProfileMap.find((profile) => lowerCase(profile.value) === lowerCase(strategyProfile)) ??
    null
  );
};
